export function parseDecimalInput(raw: string): number | null {
  const value = raw.trim()
  if (value === '') return null

  const normalised = value.replace(',', '.')
  if (!/^[-+]?\d*(?:\.\d*)?$/.test(normalised)) return null

  const parsed = Number(normalised)
  return Number.isFinite(parsed) ? parsed : null
}

export function parsePositiveIntegerInput(raw: string): number | null {
  const value = raw.trim()
  if (value === '') return null
  if (!/^\d+$/.test(value)) return null

  const parsed = Number(value)
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null
}

export function isValidCompletedRepetitionSet(reps: number | null | undefined) {
  return typeof reps === 'number' && Number.isInteger(reps) && reps > 0
}
